import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DownArrow16 = (props: SvgProps) => (
  <Svg
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <Path
      stroke={props.color || '#0058AD'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m4.666 7.166 3.333 3.333 3.334-3.333"
    />
  </Svg>
);
export default DownArrow16;
